import React from 'react'
import { Box } from '@mui/material'
import { ContentGroup } from '@ketch-com/deck'

import { useQueryParams } from 'utils/hooks/useQueryParams'
import { DataRoleType } from 'interfaces/events'
import { PolicyScopesDropList } from './PolicyScopesDropList'
import { SubjectTypeDropList } from './SubjectTypeDropList'
import { RightCodeDropList } from './RightCodeDropList'
import { ApplicationCodeDropList } from './ApplicationCodeDropList'

const RightsFiltersActionPanel = () => {
  const { setQueryParam, removeQueryParam } = useQueryParams<{
    policyScope?: string
    dataSubjectType?: string
    dataRole?: DataRoleType
    rightCode?: string
    applicationCode?: string
  }>()

  return (
    <Box gap={1} display="flex" sx={{ mt: -4 }}>
      <ApplicationCodeDropList
        onChange={value => (value ? setQueryParam('applicationCode', value) : removeQueryParam('applicationCode'))}
      />
      <PolicyScopesDropList
        onChange={value => (value ? setQueryParam('policyScope', value) : removeQueryParam('policyScope'))}
      />
      <RightCodeDropList
        onChange={value => (value ? setQueryParam('rightCode', value) : removeQueryParam('rightCode'))}
      />
      <SubjectTypeDropList
        onChange={value => (value ? setQueryParam('dataSubjectType', value) : removeQueryParam('dataSubjectType'))}
      />
    </Box>
  )
}

export const RightsFilters: React.FC = () => {
  return (
    <ContentGroup variant="top-header" titleVariant="h1" actionBottomBlockComponent={<RightsFiltersActionPanel />} />
  )
}
